import {useIntl, defineMessages} from 'react-intl';
import {Action, Icon} from '@sail/ui';
import {cancel} from '@sail/icons/react/Icon';
import {WalletCard} from 'src/v2/components/wallet/WalletCard';
import {useSelector, setValue} from 'src/v2/state/store';
import {chrome} from 'src/v2/icons/chrome';
import {firefox} from 'src/v2/icons/firefox';
import {BrowserSelector} from './BrowserSelector';

const messages = defineMessages({
  chrome: {
    id: 'crypto.payins.v2.install_wallet.chrome',
    description: 'Label for install Chrome extension',
    defaultMessage: 'Install Chrome extension',
  },
  firefox: {
    id: 'crypto.payins.v2.install_wallet.firefox',
    description: 'Label for install Firefox extension',
    defaultMessage: 'Install Firefox extension',
  },
});

export const InstallWalletScreen = () => {
  const intl = useIntl();
  const newWallet = useSelector((state) => state.newWallet);

  if (!newWallet || newWallet?.walletOption.provider === 'WalletConnect') {
    throw new Error(
      'newWallet is required in InstallWalletScreen and must not be a WalletConnect wallet',
    );
  }

  const {walletOption} = newWallet;
  const {chromeId, firefoxId} = walletOption.downloadLinks;
  const browsers = [];

  if (chromeId) {
    browsers.push({
      id: 'chrome',
      label: intl.formatMessage(messages.chrome),
      icon: chrome,
      extensionUrl: `https://chromewebstore.google.com/detail/${chromeId}`,
    });
  }
  if (firefoxId) {
    browsers.push({
      id: 'firefox',
      label: intl.formatMessage(messages.firefox),
      icon: firefox,
      extensionUrl: `https://addons.mozilla.org/firefox/addon/${firefoxId}`,
    });
  }

  return (
    <>
      <WalletCard
        wallet={{
          option: walletOption,
        }}
        headerActions={
          <Action
            onPress={() => {
              setValue((state) => {
                state.screen = 'WALLET_SELECT';
              });
            }}
          >
            <Icon icon={cancel} size="xsmall" />
          </Action>
        }
        bottomContent={<BrowserSelector browsers={browsers} />}
      />
    </>
  );
};
